<template>
  <div class="total_main">
    <div class="total_main_total">
      <div v-for="item in totalOptions" :key="item.name">
        <div>
          <img :src="item.icon" alt="" />
          <div>
            <span> {{ item.value }}{{ item.unit }} </span>
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div>
          <div v-for="ite in schoolType" :key="ite.name">
            <span>{{ ite.name }}：</span>
            <span>{{ item[ite.key] }}{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="total_main_buildcapital">
      <boxStyle title="项目建设情况">
        <template #title_right>
          <a-select v-model="jsqk" style="width: 120px; margin-left: auto" @change="handleChange"
            :dropdownClassName="'customClass'">
            <a-select-option value="GZ">高职院校</a-select-option>
            <a-select-option value="ZZ">中职院校</a-select-option>
            <a-select-option value="BK">职业本科</a-select-option>
            <a-select-option value="JG">技工院校</a-select-option>
          </a-select>
        </template>
        <div class="total_main_buildcapital_content">
          <div class="flex:1" ref="buildLeft"></div>
          <div class="flex:1" ref="buildRight"></div>
        </div>
      </boxStyle>
      <!-- 项目资金 -->
      <boxStyle title="微课思政元素">
        <template #title_right>
          <!-- <div class="total_maney">
            <div v-for="item in totalMoneyOptions" :key="item.title">
              <span>{{ item.title }}：</span>
              <span>{{ item.value }}{{ item.unit }}</span>
            </div>
          </div> -->
        </template>
        <div class="total_main_buildcapital_content" style="flex: 1; width: 100%; height: 100%; min-height: 350px"
          ref="wordCharts"></div>
      </boxStyle>
    </div>
    <div class="total_main_center">
      <boxStyle style="flex: 0.3" title="思政工作室中高职成果统计">
        <template #title_right>
          <a-select v-model="year" style="width: 120px; margin-left: auto" @change="handleChanges"
            :dropdownClassName="'customClass'">
            <a-select-option value="2021">2021</a-select-option>
            <a-select-option value="2022">2022</a-select-option>
            <a-select-option value="2023">2023</a-select-option>
            <a-select-option value="2024">2024</a-select-option>
          </a-select>
        </template>
        <div class="total_main_buildcapital_content" style="flex: 1; width: 100%; height: 100%; min-height: 350px"
          ref="achievements" id="achievements"></div>
      </boxStyle>
      <boxStyle style="flex: 0.3" title="思政实践基地">
        <div style="
            display: flex;
            flex: 1;
            overflow: hidden;
            flex-direction: column;
          ">
          <table class="tables">
            <colgroup>
              <col width="30%" />
              <col width="40%" />
              <col width="30%" />
            </colgroup>
            <thead>
              <tr>
                <th style="width: 30%">基地名称</th>
                <th style="width: 40%">基地地址</th>
                <th style="width: 30%">建设时间</th>
              </tr>
            </thead>
          </table>
          <!--<table class="tables">
          <thead>
            <tr>
              <th>基地名称</th>
              <th>基地地址</th>
              <th>建设时间</th>
            </tr>
          </thead>-->
          <div style="width:100%;overflow: hidden;height:300px;overflow-y: auto;">
            <table class="tables">
              <col width="30%" />
              <col width="40%" />
              <col width="30%" />
              <tbody>
                <tr v-for="(item, index) in list" :key="index">
                  <td>{{ item.baseName }}</td>
                  <td>{{ item.baseAddress }}</td>
                  <td>{{ item.baseFoundTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </boxStyle>
      <!-- 资金预警 -->
      <boxStyle style="flex: 0.4" title="成果统计">
        <div style="
            display: flex;
            flex: 1;
            overflow: hidden;
            flex-direction: column;
          ">
          <table class="tables">
            <colgroup>
              <!-- <col width="30%" />
              <col width="20%" />
              <col width="30%" />
              <col width="10%" />
              <col width="10%" /> -->
              <col width="40%" />
              <col width="30%" />
              <col width="30%" />
            </colgroup>
            <thead>
              <tr>
                <!-- <th style="width: 28%">名称</th>
                <th style="width: 20%">学校名称</th>
                <th style="width: 30%">类型</th>
                <th style="width: 10%">总金额</th>
                <th style="width: 12%">剩余金额</th> -->
                <th style="width: 40%">学校名称</th>
              <th style="width: 30%">思政工作室成果数量</th>
              <th style="width: 30%">特色文化育人品牌成果数量</th>
              </tr>
            </thead>
          </table>
          <!--<table class="tables">
          <thead>
            <tr>
              <th style="width: 20%">名称</th>
              <th style="width: 20%">学校名称</th>
              <th style="width: 10%">类型</th>
              <th style="width: 10%">总金额</th>
              <th style="width: 10%">剩余金额</th>
            </tr>
          </thead>-->
          <div style="width:100%;overflow: hidden;height:300px;overflow-y: auto;">
            <table class="tables">
              <!-- <col width="28%" />
              <col width="20%" />
              <col width="30%" />
              <col width="10%" />
              <col width="12%" /> -->
                <col width="40%" />
              <col width="30%" />
              <col width="30%" />
              <tbody>
                <tr v-for="(item, index) in list1" :key="index">
                  <td style="width: 40%">{{ item.schoolName }}</td>
                  <td style="width: 30%">{{ item.gzsNum }}</td>
                  <td style="width: 30%">{{ item.ppNum }}</td>
                  <!-- <td style="width: 30%">{{ item.name }}</td>
                  <td style="width: 20%">{{ item.schoolName }}</td>
                  <td style="width: 30%">{{ item.applyName }}</td>
                  <td style="width: 10%">{{ item.fundAmountStr }}</td>
                  <td style="width: 10%">{{ item.fundCostAmountStr }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </boxStyle>
    </div>
    <div class="total_main_bottom">
      <boxStyle style="flex: 0.3" title="品牌文化">
        <template #title_right>
          <a-radio-group style="margin-left: auto" v-model="sjvalue" button-style="solid" @change="handlechangeb">
            <a-radio-button value="0"> 文化 </a-radio-button>
            <a-radio-button value="1"> 精神 </a-radio-button>
          </a-radio-group>
        </template>
        <div class="total_main_buildcapital_content" style="
            flex: 1;
            width: 100%;
            height: 100%;
            min-height: 350px;
            transform: translate3d(0, 0, 0);
          " ref="brandTag"></div>
      </boxStyle>
      <boxStyle style="flex: 0.3" title="品牌内涵">
        <!-- <template #title_right>
          <a-select v-model="schoolTypes" style="width: 120px; margin-left: auto" @change="handleChange2"
            :dropdownClassName="'customClass'">
            <a-select-option value="GZ">高职院校</a-select-option>
            <a-select-option value="ZZ">中职院校</a-select-option>
            <a-select-option value="BK">职业本科</a-select-option>
            <a-select-option value="JG">技工院校</a-select-option>
          </a-select>
        </template> -->
        <div class="total_main_buildcapital_content" style="flex: 1; width: 100%; height: 100%; min-height: 350px"
          ref="wordChart"></div>
      </boxStyle>
      <boxStyle style="flex: 0.4" title="学校项目">
        <div style="
            display: flex;
            flex: 1;
            overflow: hidden;
            flex-direction: column;
          ">
          <table class="tables">
            <colgroup>
              <col width="30%" />
              <col width="10%" />
              <col width="20%" />
              <col width="25%" />
              <col width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th style="width: 30%">学校名称</th>
                <th style="width: 10%">资金总额</th>
                <th style="width: 20%">思政工作室数量</th>
                <th style="width: 25%">特色文化育人品牌数量</th>
                <th style="width: 15%">思政微课数量</th>
              </tr>
            </thead>
          </table>
          <!--<table class="tables">
          <thead>
            <tr>
              <th style="width: 25%">学校名称</th>
              <th style="width: 10%">资金总额</th>
              <th style="width: 17%">思政工作室数量</th>
              <th style="width: 25%">特色文化育人品牌数量</th>
              <th style="width: 15%">思政微课数量</th>
            </tr>
          </thead>-->
          <div style="width:100%;overflow: hidden;height:300px;overflow-y: auto;">
            <table class="tables">
              <col width="30%" />
              <col width="10%" />
              <col width="20%" />
              <col width="25%" />
              <col width="15%" />
              <tbody>
                <tr v-for="(item, index) in list2" :key="index">
                  <td style="width: 30%;cursor:pointer;" @click="gopath(item)">{{ item.realname }}</td>
                  <td style="width: 10%">{{ item.foundAmountStr }}</td>
                  <td style="width: 20%">{{ item.szStudio }}</td>
                  <td style="width: 25%">{{ item.yrBrand }}</td>
                  <td style="width: 15%">{{ item.szwk }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </boxStyle>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import Highcharts from "highcharts";
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import boxStyle from "@/components/bigData/boxStyle.vue";
import 'echarts-wordcloud';
export default {
  components: { boxStyle },
  data: () => {
    return {
      totalOptions: [
        {
          icon: require("@/assets/images/bigData/total_school.png"),
          name: "全市学校",
          value: "23",
          unit: "所",
          zy: "xxx",
          gz: "xxx",
          zz: "xxx",
          jg: "xxx",
        },
        {
          icon: require("@/assets/images/bigData/total_money.png"),
          name: "预算资金",
          value: "5200",
          unit: "元",
          zy: "xxx",
          gz: "xxx",
          zz: "xxx",
          jg: "xxx",
        },
        {
          icon: require("@/assets/images/bigData/total_home.png"),
          name: "思政工作室",
          value: "38",
          unit: "个",
          zy: "xxx",
          gz: "xxx",
          zz: "xxx",
          jg: "xxx",
        },
        {
          icon: require("@/assets/images/bigData/total_pinpai.png"),
          name: "特色文化育人品牌",
          value: "73",
          unit: "个",
          zy: "xxx",
          gz: "xxx",
          zz: "xxx",
          jg: "xxx",
        },
        {
          icon: require("@/assets/images/bigData/total_book.png"),
          name: "思政微课",
          value: "1200",
          unit: "个",
          zy: "xxx",
          gz: "xxx",
          zz: "xxx",
          jg: "xxx",
        },
      ],
      schoolType: [
        {
          name: "职业本科",
          key: "zy",
        },
        {
          name: "高职院校",
          key: "gz",
        },
        {
          name: "中职院校",
          key: "zz",
        },
        {
          name: "技工院校",
          key: "jg",
        },
      ],
      totalMoneyOptions: [
        { title: "预算金额", value: "****", unit: "元" },
        { title: "实际资金使用", value: "****", unit: "元" },
      ],
      sjvalue: '0',
      code: '',
      year: '2023',
      schoolTypes: 'GZ',
      list: [],
      list1: [],
      list2: [],
      jsqk: 'GZ',
      //    sj:{},
    };
  },
  mounted() {
    if (this.$route.query.adcode) {
      this.code = this.$route.query.adcode;
    }
    // this.getcaptital();
    this.schType();
    this.yearType();
    this.getschool();
    this.getszgzs();
    this.getts();
    this.getszwk();
    this.getbrand();
    this.getppgs();
    this.getAchiment();
    this.getFound();
    this.getcityBase();
    this.getcityWarn();
    this.getschapp();
    this.getWordChart();
    this.getWordCharts();
  },
  methods: {
     getWordCharts() {
      getAction('/analysis/wkszys', {
				applyType: '3',
        code:this.code
			}).then((res) => {
				if (res.code == '200') {
					// let result=res.result.dataList;
					const result = res.result.dataList.map(item => ({
							name: item,
							value: (Math.random() * 3 + 13).toFixed(2) // 生成13-16之间的随机数，保留2位小数
					}));
					const chart = echarts.init(this.$refs.wordCharts);
					chart.setOption({
						series: [{
							type: 'wordCloud',
							data:result,
							//  [
							// 	{ 'name': '胸怀理想', 'value': 13 },
							// 	{ 'name': '建功立业', 'value': 14 },
							// 	{ 'name': '民族自信', 'value': 16 },
							// 	{ 'name': '顽强拼搏', 'value': 15 },
							// 	{ 'name': '文化自信', 'value': 12 },
							// 	{ 'name': '奋发图强', 'value': 13 },
							// 	{ 'name': '刚健有为', 'value': 14 },
							// ],
							sizeRange: [16, 30],
							textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
						}]
					});
					// this.gethh(res.result.cityList, res.result.dataList, res.result.rateList, res.result.schoolTypeList);
				}
			});
      // const chart = echarts.init(this.$refs.wordCharts);
      // chart.setOption({
      //   series: [{
      //     type: 'wordCloud',
      //     data: [
      //       { 'name': '胸怀理想', 'value': 13 },
      //       { 'name': '建功立业', 'value': 14 },
      //       { 'name': '民族自信', 'value': 16 },
      //       { 'name': '顽强拼搏', 'value': 15},
      //       { 'name': '文化自信', 'value': 12 },
      //       { 'name': '奋发图强', 'value': 13},
      //       { 'name': '刚健有为', 'value': 14 },
      //       ],
      //     sizeRange: [16, 30],
      //     textStyle: { color: () => this.randomColor(),fontSize: '18-50' }
      //   }]
      // });
    },
    gopath(item) {
      this.$router.push({
        path: '/home/schoolAnalyse',
        query: {
          name: item.realname,
          schoolid: item.id,
        }
      });
    },
    getschapp() {
      getAction('/analysis/schoolApply', {
        code: this.code,
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.code == '0') {
          this.list2 = res.result.records;
        }
      });
    },
    getcaptital() {
      getAction('/analysis/capitalSource', {
        code: this.code,
      }).then((res) => {
        if (res.code == '200') {
          //						   this.sj=res.result;
          this.totalMoneyOptions[0].value = res.result.totalAmount;
          this.totalMoneyOptions[1].value = res.result.totalCost;
          this.totalManey(res.result);
        }
      });
    },
    yearType() {
      getAction('/analysis/yearApplyType', {
        code: this.code,
        schoolType: this.jsqk,
      }).then((res) => {
        if (res.code == '200') {
          this.buildRight(res.result);
        }
      });
    },
    schType() {
      getAction('/analysis/schoolTypeApplyType', {
        code: this.code,
      }).then((res) => {
        if (res.code == '200') {
          let typeList = res.result.typeList, dataList = res.result.dataList;
          let arr = [], arr1 = [];
          for (var i = 0; i < typeList.length; i++) {
            arr.push({ name: typeList[i] });
          }
          for (var j = 0; j < dataList.length; j++) {
            arr1.push(dataList[j].name);
          }
          this.buildLeft(arr, arr1, dataList);
        }
      });
    },
    getcityBase() {
      getAction('/analysis/cityApplyBase', {
        code: this.code,
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        //					console.log(res.result);
        if (res.code == '0') {
          this.list = res.result.records;
        }
      });
    },
    getcityWarn() {
      // /analysis/cityFundWarning
      getAction('/analysis/szTypeAchievementByCode', {
        code: this.code,
        // pageNo: 1,
        // pageSize: 1000,
      }).then((res) => {
        //					console.log(res.result,"11111");
        if (res.code == '0') {
          // this.list1 = res.result.records;
           this.list1 = res.result.dataList;
        }
      });
    },
    getFound() {
      getAction('/analysis/cityApplyFund', {
        code: this.code,
      }).then((res) => {
        if (res.code == '200') {
          this.totalOptions[1].value = res.result.totalNum;
          this.totalOptions[1].zy = res.result.BK;
          this.totalOptions[1].gz = res.result.GZ;
          this.totalOptions[1].zz = res.result.ZZ;
          this.totalOptions[1].jg = res.result.JG;
        }
      });
    },
    getAchiment() {
      getAction('/analysis/szTypeAchievement', {
        code: this.code,
        year: this.year,
      }).then((res) => {
        //					console.log(res);
        if (res.code == '200') {
          this.achievementsAct(res.result);
        }
      });
    },
    handleChanges() {
      this.getAchiment();
    },
    getszgzs() {
      getAction('/analysis/cityApplyNum', {
        code: this.code,
        applyType: '1'
      }).then((res) => {
        //					console.log(res);
        if (res.code == '200') {
          this.totalOptions[2].value = res.result.totalNum;
          this.totalOptions[2].zy = res.result.BK;
          this.totalOptions[2].gz = res.result.GZ;
          this.totalOptions[2].zz = res.result.ZZ;
          this.totalOptions[2].jg = res.result.JG;
        }
      });
    },
    getts() {
      getAction('/analysis/cityApplyNum', {
        code: this.code,
        applyType: '2'
      }).then((res) => {
        //					console.log(res);
        if (res.code == '200') {
          this.totalOptions[3].value = res.result.totalNum;
          this.totalOptions[3].zy = res.result.BK;
          this.totalOptions[3].gz = res.result.GZ;
          this.totalOptions[3].zz = res.result.ZZ;
          this.totalOptions[3].jg = res.result.JG;
        }
      });
    },
    getszwk() {
      getAction('/analysis/cityApplyNum', {
        code: this.code,
        applyType: '3'
      }).then((res) => {
        //					console.log(res);
        if (res.code == '200') {
          this.totalOptions[4].value = res.result.totalNum;
          this.totalOptions[4].zy = res.result.BK;
          this.totalOptions[4].gz = res.result.GZ;
          this.totalOptions[4].zz = res.result.ZZ;
          this.totalOptions[4].jg = res.result.JG;
        }
      });
    },
    getschool() {
      getAction('/analysis/citySchoolNum', {
        code: this.code,
      }).then((res) => {
        //					console.log(res);
        if (res.code == '200') {
          this.totalOptions[0].value = res.result.totalNum;
          this.totalOptions[0].zy = res.result.BK;
          this.totalOptions[0].gz = res.result.GZ;
          this.totalOptions[0].zz = res.result.ZZ;
          this.totalOptions[0].jg = res.result.JG;
        }
      });
    },
    getppgs() {
      getAction('/analysis/schoolTypeMajorCategory', {
        applyType: '2',
        schoolType: this.schoolTypes,
        code: this.code,
      }).then((res) => {
        //					console.log(res,"222222");
        if (res.code == '200') {
          let arr = [];
          let sj = res.result.dataList;
          for (var i = 0; i < sj.length; i++) {
            let arr1 = [];
            arr1.push(sj[i].name);
            arr1.push(sj[i].value);
            arr.push(arr1);
          }
          // this.星星星(arr);
        }
      });
    },
    handleChange2() {
      this.getppgs();
    },
    handleChange() {
      this.yearType();
    },
    handlechangeb() {
      this.getbrand();
    },
    getbrand() {
      getAction('/analysis/brandLabel', {
        applyType: '2',
        sort: this.sjvalue,
        code: this.code,
      }).then((res) => {
        //					console.log(res,"222222");
        if (res.code == '200') {
          let list = [{
            label: {
              textStyle: {
                color: "#106bff",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#00b8ff",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#ff6262",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#ffb81a",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#6fef33",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#6faf33",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#106bff",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#8d4bbb",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#6635EF",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#FFAFDA",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }, {
            label: {
              textStyle: {
                color: "#106bff",
                fontSize: 18,
                fontWeight: 600,
                borderColor: "#517FD9",
              },
            }
          }];
          let sj = res.result;
          let arr = [];
          for (var i = 0; i < sj.length; i++) {
            arr.push({ name: sj[i].name, value: sj[i].value, label: list[i].label });
          }
          this.brandTagAct(arr);
        }
      });
    },
    buildLeft(arr, arr1, datalist) {
      var myChart = echarts.init(this.$refs.buildLeft);
      let option = {
        title: {
          text: "",
        },
        legend: {
          data: arr1,
          left: "center",
          textStyle: {
            color: "#E9EAEF", // 设置图例文本颜色
          },
          itemWidth: 12, // 设置图例标记的宽度
          itemHeight: 8,
        },
        radar: {
          // shape: 'circle',
          indicator: arr,
          shape: "polygon",
          radius: "60%",
          splitNumber: 5,
          name: {
            textStyle: {
              color: "#fff", // 指示器名称的文字颜色
            },
          },
          axisLine: {
            lineStyle: {
              color: "#004779", // 中间x轴和y轴的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: ["#004779", "#004779", "#004779"], // 分隔线颜色
            },
          },
          splitArea: {
            // 区域填充样式
            show: true, // 显示分隔区域
            areaStyle: {
              color: ["rgba(0,0,0,0)", "RGBA(0, 46, 113,0.5)"], // 分割区域的颜色数组
            },
          },
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: [
              {
                value: datalist[0].value,
                name: datalist[0].name,
                itemStyle: {
                  color: "#5470C6",
                },
              },
              {
                value: datalist[1].value,
                name: datalist[1].name,
                itemStyle: {
                  color: "#91CC75",
                },
              },
              {
                value: datalist[2].value,
                name: datalist[2].name,
                itemStyle: {
                  color: "#FAC858",
                },
              },
            ],
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    buildRight(res) {
      let value = res.yearList;
      let value1 = res.dataList[0];
      let value2 = res.dataList[1];
      let value3 = res.dataList[2];
      let VALUE5 = res.applyTypeList;
      var myChart = echarts.init(this.$refs.buildRight);
      let option = {
        grid: {
          containLabel: true,
          left: 15,
          right: 15,
          bottom: 15,
          top: 48,
        },
        legend: {
          data: VALUE5,
          textStyle: {
            color: "#ffffff", //字体颜色
          },
          origent: "right",
          top: 0,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: value,
          axisLabel: {
            textStyle: {
              color: "#68A8CC",
            },
            formatter: function (value) {
              let rowMAx = 4;
              let overValue = "";
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += "\n";
                  overValue += value[i];
                } else {
                  overValue += value[i];
                }
              }
              return overValue;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#3c71c1",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(个)",
          nameTextStyle: {
            color: "#68A8CC",
          },
          axisLabel: {
            textStyle: {
              color: "#68A8CC",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#68A8CC",
            },
          },
          splitLine: {
            // y 轴分隔线配置
            show: true, // 是否显示分隔线
            lineStyle: {
              color: "#68A8CC", // 分隔线颜色
            },
          },
        },
        series: [
          {
            name: VALUE5[0],
            data: value1,
            type: "bar",
            barWidth: "15",
            barGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.3,
                      color: "#56feff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0118ab", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            showBackground: false,
            backgroundStyle: {
              color: "#04195e",
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
          {
            name: VALUE5[1],
            data: value2,
            type: "bar",
            barWidth: "15",
            barGap: "40%",
            showBackground: false,
            backgroundStyle: {
              color: "#04195e",
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.4,
                      color: "#9ff077", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0a781b", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
          {
            name: VALUE5[2],
            data: value3,
            type: "bar",
            barGap: "40%",
            barWidth: "15",
            showBackground: false,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.4,
                      color: "#ffff78", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#d94a1a", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
            legend: {
              color: "#011b60",
            },
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    totalManey(res) {
      var myChart = echarts.init(this.$refs.totalManey);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        toolbox: {
          show: false,
        },
        legend: {
          data: ["总金额", "总支出", "资金使用率"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          containLabel: true,
          left: 5,
          right: 15,
          bottom: 15,
          top: 30,
        },
        xAxis: [
          {
            type: "category",
            data: res.typeList,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              textStyle: {
                color: "#AADDFF",
              },
              formatter: function (value) {
                let rowMAx = 4;
                let overValue = "";
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += "\n";
                    overValue += value[i];
                  } else {
                    overValue += value[i];
                  }
                }
                return overValue;
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#0F2C70",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "(万元)",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: "{value}",
            },
            nameTextStyle: {
              color: "#63A1C6",
            },
            axisLabel: {
              textStyle: {
                color: "#63A1C6",
              },
            },
          },
          {
            type: "value",
            name: "(%)",
            min: 0,

            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%",
            },
            nameTextStyle: {
              color: "#63A1C6",
            },
            axisLabel: {
              textStyle: {
                color: "#63A1C6",
              },
            },
          },
        ],
        series: [
          {
            name: "总金额",
            type: "bar",
            barWidth: "20",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#0095fe", // 描边颜色
                borderWidth: 2, // 描边宽度
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.3,
                      color: "#0096FFee", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#000000bb", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            data: res.outDataList[0],
          },
          {
            barWidth: "20",
            name: "总支出",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#d78404", // 描边颜色
                borderWidth: 2, // 描边宽度
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.3,
                      color: "#ff9f0dee", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#000000bb", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            data: res.outDataList[1],
          },
          {
            name: "资金使用率",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            lineStyle: {
              color: "#38CEC1", // 修改折线颜色
            },
            itemStyle: {
              color: "#fff", // 点的填充颜色
              borderColor: "#38CEC1", // 点的描边颜色
              borderWidth: 2, // 描边宽度
            },
            data: res.rateList,
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    achievementsAct(data2) {
      var myChart = echarts.init(this.$refs.achievements);
      let color = ["#FFD900", "#517FD9", "#FF7E00", "#00A1E4"];
      let data1 = [];
      for (var i = 0; i < data2.length; i++) {
        data1.push({
          value: data2[i].schoolNum,
          name: data2[i].name,
          value1: data2[i].rate,
        })
      }
      //    let data1 = [
      //      {
      //        value: 120,
      //        name: "职业本科",
      //        value1: "95",
      //        label: {
      //          textStyle: {
      //            color: "#FFD900",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#FFD900",
      //          },
      //        },
      //      },
      //      {
      //        value: 20,
      //        name: "高职院校",
      //        value1: "90",
      //        label: {
      //          textStyle: {
      //            color: "#517FD9",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#517FD9",
      //          },
      //        },
      //      },
      //      {
      //        value: 156,
      //        name: "中职院校",
      //        value1: "80",
      //        label: {
      //          textStyle: {
      //            color: "#FF7E00",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#FF7E00",
      //          },
      //        },
      //      },
      //      {
      //        value: 33,
      //        name: "技工院校",
      //        value1: "70",
      //        label: {
      //          textStyle: {
      //            color: "#00A1E4",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#00A1E4",
      //          },
      //        },
      //      },
      //    ];
      data1.sort(function (a, b) {
        return a.value - b.value;
      });
      color.splice(data1.length, data1.length - 1);
      data1.map((item, index) => {
        data1.push({ value: 0, name: "" });
        color.push("transparent");
      });
      let option = {
        backgroundColor: "",
        title: {
          text: "",
        },
        tooltip: {
          show: false,
        },
        legend: {
          icon: "circle",
          top: "1%",
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "玫瑰图",
            type: "pie",
            startAngle: 180,
            radius: [50, 100],
            center: ["50%", "90%"],
            roseType: "area",
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  return color[params.dataIndex];
                },
              },
            },
            label: {
              show: true,
              fontSize: 14,
              formatter: function (params) {
                return params.data.name + ":" + params.data.value1 + "%";
              },
              textStyle: {
                color: "#fff",
              },
              rich: {
                hr: {
                  width: "100%",
                  borderWidth: 0.5,
                  borderColor: "#fff",
                  height: 0,
                },
                b: {
                  color: "#fff",
                },
                // 可以添加更多的样式定义
              },
            },
            labelLine: {
              normal: {
                length: 10,
                length2: 10,
                show: true,
                lineStyle: {
                  width: 1,
                },
              },
            },
            data: data1,
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    星星星(arr) {
      Highcharts.chart(this.$refs["****"], {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 50,
            beta: 0,
          },
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: true,
          itemHoverStyle: {
            color: '#02f4f5'  // 修改图例悬停时文本颜色为蓝色
          },
          itemStyle: {
            color: "#fff",
            fontSize: "10",
          },
          //   width: 100, // 设置图例宽度
          symbolHeight: 10, // 调整图例符号高度
          symbolWidth: 10, // 调整图例符号宽度
          symbolRadius: 0, // 调整图例符号圆角
          //        itemMarginTop: 10,
          align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
          verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
          labelFormatter: function () {
            return this.name;
          },
        },
        plotOptions: {
          pie: {
            size: 220,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2,
            borderColor: "#FFFFFF", // 设置边框颜色为白色
            dataLabels: {
              distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: false, //是否显示饼图的线形tip
            },
          },
        },
        series: [
          {
            // size: 150,
            name: "品牌归属",
            data: arr,
            colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9", "#38CEC1"],
          },
        ],
      });
    },
    brandTagAct(list) {
      var myChart = echarts.init(this.$refs.brandTag);
      //    let list = [
      //      {
      //        name: "非遗文化",
      //        value: 8,
      //        label: {
      //          textStyle: {
      //            color: "#106bff",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#517FD9",
      //          },
      //        },
      //      },
      //      {
      //        name: "革命文化",
      //        value: 4,
      //        label: {
      //          textStyle: {
      //            color: "#00b8ff",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#517FD9",
      //          },
      //        },
      //      },
      //      {
      //        name: "红色文化",
      //        value: 33,
      //        label: {
      //          textStyle: {
      //            color: "#ff6262",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#517FD9",
      //          },
      //        },
      //      },
      //      {
      //        name: "传统文化",
      //        value: 48,
      //        label: {
      //          textStyle: {
      //            color: "#ffb81a",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#517FD9",
      //          },
      //        },
      //      },
      //      {
      //        name: "其他",
      //        value: 7,
      //        label: {
      //          textStyle: {
      //            color: "#6fef33",
      //            fontSize: 18,
      //            fontWeight: 600,
      //            borderColor: "#517FD9",
      //          },
      //        },
      //      },
      //    ];
      //    let list1 = [
      //	        {
      //	          name: "非遗文化",
      //	          value: 8,
      //	          itemStyle: { color: 'rgba(16,108,255,0.3)' } 
      //	        },
      //	        {
      //	          name: "革命文化",
      //	          value: 4,
      //	          itemStyle: { color: 'rgba(0,184,255,0.3)' } 
      //	        },
      //	        {
      //	          name: "红色文化",
      //	          value: 33,
      //	          itemStyle: { color: 'rgba(255,98,98,0.3)' } 
      //	        },
      //	        {
      //	          name: "传统文化",
      //	          value: 48,
      //	          itemStyle: { color: 'rgba(255,184,26,0.3)' } 
      //	        },
      //	        {
      //	          name: "其他",
      //	          value: 7,
      //	          itemStyle: { color: 'rgba(111,239,51,0.3)'} 
      //	        },
      //	      ];

      let angle = 0;
      let option = {
        color: [
          "#106bff",
          "#00b8ff",
          "#ff6262",
          "#ffb81a",
          "#6fef33",
          "#106bff",
          "#8d4bbb",
          "#6635EF",
          "#FFAFDA",
        ],
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        series: [
          //        {
          //          name: "访问来源",
          //          type: "pie",
          //          selectedMode: "single",
          //          radius: ["47%", "58%"],
          //
          //          label: {
          //            normal: {
          //              show: false,
          //              position: "inner",
          //              formatter: "{d}%",
          //              textStyle: {
          //                color: "#fff",
          //                fontWeight: "normal",
          //                fontSize: 20,
          //              },
          //            },
          //          },
          //          labelLine: {
          //            normal: {
          //              show: false,
          //            },
          //          },
          //          itemStyle: {
          //            normal: {
          //              borderColor: "#001553",
          //              borderWidth: 4,
          //            },
          //          },
          //          data: list1,
          //        },
          {
            itemStyle: {
              normal: {
                borderColor: "#001553",
                borderWidth: 4,
              },
            },
            name: "访问来源",
            type: "pie",
            radius: ["47%", "58%"],
            label: {
              normal: {
                formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
                rich: {
                  b: {
                    fontSize: 16,
                    align: "left",
                    padding: 4,
                  },
                  hr: {
                    borderColor: "#12EABE",
                    width: "100%",
                    borderWidth: 2,
                    height: 0,
                  },
                  d: {
                    fontSize: 16,
                    color: "#fff",
                    align: "left",
                    padding: 4,
                  },
                  c: {
                    fontSize: 16,
                    color: "#fff",
                    align: "center",
                    padding: 4,
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
                length: 20,
                length2: 20,
                lineStyle: {
                  type: "dashed",
                  width: 2,
                },
              },
            },

            data: list,
          },
          {
            name: "ring5",
            type: "custom",
            hoverAnimation: false,
            clockwise: true,
            coordinateSystem: "none",
            z: 20, // 设置 markPoint 的 z-index
            zlevel: 2, // 设置 markPoint 的 zlevel
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.25,
                  startAngle: ((270 + -angle) * Math.PI) / 180,
                  endAngle: ((40 + -angle) * Math.PI) / 180,
                },
                style: {
                  shadowColor: "#4FADFD",
                  shadowBlur: 10,
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "访问来源",
            type: "pie",
            clockwise: true,
            hoverAnimation: false,
            coordinateSystem: "none",
            radius: ["0%", "30%"],
            data: [100],
            itemStyle: {
              normal: {
                color: "#043173",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              normal: {
                show: false,
                length: 20,
                length2: 20,
                lineStyle: {
                  type: "dashed",
                  width: 2,
                },
              },
            },
          },
        ],
      };
      myChart.clear();
      //    function draw() {
      //      angle = angle + 3;
      //      myChart.setOption(option, true);
      //      //window.requestAnimationFrame(draw);
      //    }
      //
      //    myChart.on("finished", function () {
      //      setInterval(function () {
      //        //用setInterval做动画感觉有问题
      //        draw();
      //      }, 100);
      //      // 在这里执行你想要在渲染完成后执行的代码
      //    });

      myChart.setOption(option);
    },
   getWordChart() {
     getAction('/analysis/brandConnotation', {
				applyType: '2',
        code: this.code,
			}).then((res) => {
				if (res.code == '200') {
					// let result=res.result.dataList;
					const result = res.result.dataList.map(item => ({
							name: item,
							value: (Math.random() * 3 + 13).toFixed(2) // 生成13-16之间的随机数，保留2位小数
					}));
					const chart = echarts.init(this.$refs.wordChart);
					chart.setOption({
						series: [{
							type: 'wordCloud',
							data:result,
							sizeRange: [16, 30],
							textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
						}]
					});
					// this.gethh(res.result.cityList, res.result.dataList, res.result.rateList, res.result.schoolTypeList);
				}
			});
      // const chart = echarts.init(this.$refs.wordChart);
			// chart.setOption({
			// 	series: [{
			// 		type: 'wordCloud',
			// 		data: [
			// 			{ 'name': '爱国主义', 'value': 13 },
			// 			{ 'name': '理想信念', 'value': 14 },
			// 			{ 'name': '责任担当', 'value': 16 },
			// 			{ 'name': '大国工匠', 'value': 15 },
			// 			{ 'name': '劳模精神', 'value': 12 },
			// 			{ 'name': '劳动精神', 'value': 13 },
			// 			{ 'name': '法治规范', 'value': 15 },
			// 			{ 'name': '社会主义核心价值观', 'value': 15 },
			// 			{ 'name': '道德修养', 'value': 17 },],
			// 		sizeRange: [16, 30],
			// 		textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
			// 	}]
			// });
    },
    randomColor() {
      const h = Math.floor(Math.random() * 360);
			const s = 80 + Math.floor(Math.random() * 20);
			const l = 60 + Math.floor(Math.random() * 30);

			// HSL转RGB再转HEX
			const a = s * Math.min(l, 100 - l) / 100;
			const f = n => {
				const k = (n + h / 30) % 12;
				const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
				return Math.round(255 * color / 100).toString(16).padStart(2, '0');
			};
			return `#${f(0)}${f(8)}${f(4)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.total_main {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;

  /*background: url("../../assets/images/bigdatas/banner.png") no-repeat;*/
  >div {
    >div {
      &:not(:last-child) {
        margin-right: 0.4vw;
      }
    }
  }

  &_total {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-height: 120px;
    margin-bottom: 12px;

    >div {
      flex: 1;
      background: url("~@/assets/images/bigData/total_bg.png") no-repeat;
      background-size: 100% 100%;
      padding: 0.9vh 0.22vw;
      display: flex;
      flex-direction: row;

      >div {
        display: flex;
        flex: 1;
        padding: 0px 0.2vw;

        &:first-child {
          display: flex;
          justify-content: center;
          align-items: center;

          >img {
            width: 2.5vw;
            height: 2.5vw;
            margin-right: 5px;
          }

          >div {
            display: flex;
            flex-direction: column;

            >span {
              text-align: left;
              font-family: MicrosoftYaHei, MicrosoftYaHei;
              font-style: normal;
              text-transform: none;

              &:first-child {
                font-weight: bold;
                font-size: 1.1vw;
                color: #ffd70e;
              }

              &:last-child {
                font-size: 0.8vw;
                color: #ffffff;
              }
            }
          }
        }

        &:last-child {
          display: flex;
          align-content: center;
          /*align-items: center;*/
          justify-content: center;
          flex-direction: column;

          >div {
            font-family: MicrosoftYaHei;
            font-size: 0.8vw;
            color: #ffffff;
            text-align: left;
            font-style: normal;
            text-transform: none;

            >span {
              &:last-child {
                color: #66d6dc;
              }
            }
          }
        }
      }

      &:not(:last-child) {
        margin-right: 9px;
      }
    }
  }

  &_buildcapital {
    display: flex;
    flex-direction: row;

    &_content {
      flex: 1;
      width: 100%;
      display: flex;
      min-height: 350px;
      padding: 20px;

      >div {
        flex: 1;

        &:first-child {
          min-width: 350px;
          flex: 0.4;
          border-right: 1px solid #072b72;
        }
      }
    }
  }

  &_center {
    display: flex;
    flex-direction: row;
  }

  &_bottom {
    display: flex;
    flex-direction: row;
  }
}

.total_maney {
  display: flex;
  flex: 1;
  justify-content: flex-end;

  >div {
    &:first-child {
      margin-right: 15px;
    }

    >span {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: 400;

      &:first-child {
        color: #ffffff;
      }

      &:last-child {
        color: #efcb1a;
      }
    }
  }
}

.tables {
  width: 100%;

  thead {
    tr {
      background-color: #082569;
      height: 47px;

      th {
        width: 20%;
        height: 38px;
        font-weight: 500;
        line-height: 38px;
        text-align: center;
        font-size: 0.9vw;
        color: #8298fb;
      }
    }
  }

  tbody {
    tr {
      height: 25px;
      border-bottom: 1px solid #213e78;

      td {
        width: 20%;
        height: 36px;
        font-weight: 300;
        line-height: 36px;
        text-align: center;
        font-size: 0.8vw;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0px;
  /* 滚动条宽度 */
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 滚动条轨道背景色 */
  border-radius: 10px;
  /* 可选：轨道圆角 */
}

::-webkit-scrollbar-thumb {
  background: #888;
  /* 滚动条颜色 */
  border-radius: 10px;
  /* 可选：滚动条圆角 */
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 鼠标悬停时滚动条颜色 */
}

* {
  transform: translate3d(0, 0, 0);
}
</style>
